import { Injectable } from '@angular/core';
import { LoginService } from './login.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Subject, Subscription, BehaviorSubject,Observable } from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  examsSettings =[]
  cardioExamsDefault =['אקו',
  'TTE Adults',
  'TTE Pediatric',
  'Stress-Echo',
  'Duplex Carotid',
  'Stress',
  'Holter ECG',
  'Consultation Letter']
  gastroExamsDefault = [
    'Colonoscopy',
    'Gastroscopy',
    'Gastro-Colonoscopy',
    'Sigmoidoscopy',
    'Abdomen US'
  ]
  eyesExamsDefault = [
    'FOV',
    'OCT',
    'FOV + OCT',
    'Pachymetry'
  ]
  obgynExamsDefault = [
    '1st',
    'NT',
    'Early Anatomy',
    '2nd/3rd Trimester',
    'Late Anatomy',
    'Specialized',
    'Fetal Echo',
    'Pediatric Echo',
    'Weight Assessment',
    'Tech Exam',
    'Gynecology',
    'Follicles',
    'Consultation Visit',
    'Third Scan'
  ]

  categories = {
    Pregnancy: [
      "1st",
      "NT",
      "Early Anatomy",
      "2nd/3rd Trimester",
      "Late Anatomy",
      "Specialized",
      "Weight Assessment",
      "Tech Exam",
      "Consultation Visit",
      "Third Scan",
    ],
    Gynecology: ["Gynecology"],
    "Fetal Echo": ["Fetal Echo"],
    "Pediatric Echo": ["Pediatric Echo"],
    Cardio: this.cardioExamsDefault,
  };

  public examsSettingsLoaded$: Subject<void> = new Subject<void>();
  
  constructor(public loginService: LoginService,private http:HttpClient,private translate: TranslateService) {
    this.translate.use('he-IL');
  }


  getDefault(){
    if (this.loginService.isCardio){
      return this.cardioExamsDefault
  }

  if(this.loginService.isEyes){
    return this.eyesExamsDefault
  }

  if(this.loginService.isGastro){
    return this.gastroExamsDefault
  }
  return this.obgynExamsDefault
}

async getExams(GID){
  try {
    const data = await this.http.get(`api/settings/${GID}`).toPromise();
    this.examsSettings=data['exams']
    const exams=data['exams'].map((exam)=>{
    exam['category']=this.getCategory(exam['examType']);

      return exam
    })
    this.examsSettingsLoaded$.next(exams);
    return exams
  } catch (error) {
    console.error('Error fetching exams settings:', error);
    return []
  }
}

getAvailableHMOs(GID: string) {
  return this.http.get< any[] >(`api/settings/available/HMOs`, { params: { GID } });
}

validateExamCode(GID, HMO, code) {
  return this.http.post<any>(`api/settings/validate-code`, { GID, HMO, code }).toPromise();
}

getClinic(GID){
  return this.http.get<any[]>(`api/settings/clinic/${GID}`)
}

getCategory(examType) {
  for (const category in this.categories) {
    if (this.categories[category].includes(examType)) {
      return category;
    }
  }
  return 'Unknown'; // Return 'Unknown' or some default value if no match is found
}


async updateExam(Exam): Promise<any>{
  if (Exam.AutoIndex == null) {
    throw new Error('AutoIndex is not set.');
  }

  try {
    return this.http.put(`/api/settings`,Exam).toPromise();
   
    
  } catch (error) {
    console.error('Error update exam:', error);
    throw error;
  }
}

async saveNewExam(exam){
  return this.http.post('/api/settings/',exam).toPromise()
}


async patientActivities(GID: number, PID: number) {
  const params = new HttpParams()
    .set('gid', GID)  
    .set('pid', PID);

  return this.http.get('/api/settings/patient-activities', { params }).toPromise();
}



getExam(AutoIndex){
  return this.examsSettings.find((exam)=>{exam.AutoIndex==AutoIndex})
}


getHolidays(year: number){
 return this.http.get<any[]>(`api/settings/holidays/${year}`)
}


getActivityHours(UID=null,GID=null): Observable<any> {
  if(!UID || !GID) return
  let url = `api/settings/activity-hours/${UID}/${GID}`;
  return this.http.get(url);
}


saveActivityHours(data: any): Observable<any> {
  const body={UID:this.loginService.doctor,days:data}
  return this.http.post(`api/settings/activity-hours`, body);
}

search(searchType,start,end,UID){
if (searchType=='deleted'){
  return this.http.get<any[]>(`api/appointment/deleted/`,{params:{start,end,UID}})
}
}


getSmsData(){
 return this.http.get<any>('api/settings/smsClinicData')
}

sendSmsData(smsObj){
return this.http.post('api/settings/smsCliniCData',smsObj)
}

fetchSlots(date,GID,UID,slotLength){
  return this.http.post('api/settings/slots',{date,GID,UID,slotLength})
}

getSlotsRange(minDate,maxDate,GID, UID, slotLength, activityHours,HMO=null){
  return this.http.post('api/settings/slotsRange',{minDate,maxDate,GID,UID,slotLength,activityHours,HMO})
}

IdentityVerification(PID=undefined,Mobile=undefined){
  return this.http.post('api/settings/Verification',{PID,Mobile})
}

checkVerification(code,codeId){
  return this.http.post('api/settings/VerificationValid',{code,codeId})
}

}





